import React, { memo } from 'react'
import { TooltipPositionTypes } from '../../libraries/Tooltips'
import { getMergedClassNames } from '../../utils/HTMLutils'
import './Col.scss'
const rootClassName = 'component-col'

interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  'tooltip-position'?: TooltipPositionTypes
  'tooltip-text'?: string
  cols?: Array<1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12>
  centralized?: boolean
  end?: boolean
  noPadding?: boolean
  children?: React.ReactNode
}

function Col(props: ColProps) {
  const getProps = () => {
    const cols = props.cols ? props.cols : [12, 12, 12, 12, 12]
    const size = ['xs', 'sm', 'md', 'lg', 'xl']
    const getSizes = cols.map((n, index) => {
      return `${rootClassName}-${size[index]}-${n}`
    })
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className,
        props.centralized ? 'centralized' : '',
        props.end ? 'end' : '',
        props.noPadding ? 'no-padding' : '',
        ...getSizes
      ])
    }
    delete p.noPadding
    delete p.centralized
    delete p.end
    delete p.cols
    return p
  }

  return <div {...getProps()}>{props.children}</div>
}

Col.defaultProps = {
  cols: [12, 12, 12, 12, 12],
  centralized: false,
  end: false,
  noPadding: false
}

export default memo(Col)
